import { render, staticRenderFns } from "./DialogConfirmDeleteComment.vue?vue&type=template&id=9914a7c4&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./DialogConfirmDeleteComment.vue?vue&type=script&lang=js"
export * from "./DialogConfirmDeleteComment.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmDeleteComment.vue?vue&type=style&index=0&id=9914a7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9914a7c4",
  null
  
)

export default component.exports